import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, formatErr, imgUrl } from "@/lib/api";
import { ImageUploader } from "./ImageUploader";

/** Fotografia mostrata nella pagina di accesso all'area clienti. */
export const ClientLoginImage = () => {
  const [img, setImg] = useState(null);
  const [fallback, setFallback] = useState("");
  useEffect(() => {
    api.get("/admin/settings").then((r) => setImg(r.data.client_login_image || ""));
    api.get("/public/services").then(({ data }) => setFallback(data.find((s) => s.cover)?.cover || ""));
  }, []);

  const save = async (value) => {
    try {
      const { data } = await api.get("/admin/settings");
      await api.put("/admin/settings", { ...data, client_login_image: value });
      setImg(value);
      toast.success(value ? "Fotografia aggiornata" : "Fotografia rimossa");
    } catch (e) { toast.error(formatErr(e)); }
  };

  if (img === null) return null;
  const shown = img || fallback;
  return (
    <div className="admin-card p-5 mb-6 max-w-2xl" data-testid="client-login-image">
      <p className="text-sm font-semibold">Fotografia della pagina di accesso</p>
      <p className="text-xs text-slate-500 mt-1">È la grande fotografia a sinistra nella pagina /area-clienti. Formato verticale consigliato.</p>
      <div className="mt-4 flex items-center gap-4 flex-wrap">
        <div className="relative w-28 h-36 bg-cream rounded overflow-hidden">
          {shown && <img src={imgUrl(shown)} alt="" className="w-full h-full object-cover" data-testid="client-login-image-preview" />}
          {img && <button type="button" onClick={() => save("")} className="absolute top-1 right-1 bg-white/90 rounded p-1 text-terracotta" aria-label="Rimuovi" data-testid="client-login-image-clear"><X size={12} /></button>}
        </div>
        <div>
          <ImageUploader multiple={false} label={img ? "Sostituisci" : "Carica fotografia"} onUploaded={(u) => save(u[0])} testid="client-login-image-upload" />
          {!img && <p className="text-[11px] text-slate-500 mt-2">Nessuna foto impostata: viene usata la copertina della prima categoria visibile.</p>}
        </div>
      </div>
    </div>
  );
};
